
export function Technology() {
  return (
    <section id="technology" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="aspect-[4/3] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=advanced%20artificial%20intelligence%20technology%20dashboard%20holographic%20display%20showing%20flight%20management%20system%20data%20analytics%20modern%20clean%20interface%20blue%20and%20teal%20colors%20professional%20technology%20photography&width=1000&height=750&seq=tech1&orientation=landscape"
              alt="DJT Technology Platform"
              className="w-full h-full object-cover"
            />
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-500 mb-2 tracking-wider">
              MEET THE DJT IQ
            </p>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6">
              The platform destined to accelerate Urban Air Mobility
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              DJT IQ is the backbone of our Urban Air Mobility ecosystem. Powered by Artificial Intelligence and advanced cloud computing, it provides tech-enabled insights to manage and optimize aircraft fleets and urban integration efforts.
            </p>
            <button className="inline-flex items-center px-8 py-3 bg-gray-900 text-white rounded-full hover:bg-gray-800 transition-colors group whitespace-nowrap">
              <span>Learn more</span>
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
